import React from "react"
import { UrlService } from "../../../../core/services/UrlService"
import "./Footer.scss"

const Footer: React.FC<any> = () => {
    return (
        <section>
            <div className="self-test-footer">
                <div className="self-test-footer_container">
                    <div className="self-test-footer_description">
                        <div className="self-test-footer_description_image">
                            <img
                                className="description_icon"
                                src={UrlService.getLocalImageUrl(
                                    "self-test/covid/img02.png?1"
                                )}
                                title="Description"
                                alt="Description"
                            />
                        </div>
                        <div className="self-test-footer-description_content">
                            <h2 className="self-test-footer-description_title">
                                您知道嗎？
                            </h2>
                            <div className="self-test-footer-description_text">
                                <p>
                                    最近醫管局已購入/香港已引進兩款治療新型冠狀病毒的⼝服藥 — 帕克斯洛維德(Paxlovid)和莫納⽪拉⾱(Molnupiravir) 。研究指出，在症狀出現後 5 天內盡快開始治療可降低住院或死亡風險。<sup>6</sup> 因此患者在出現病徵後應盡早求醫，以減低病情惡化的風險。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="self-test-footer_statistic">
                        <div className="self-test-footer_statistic-item">
                            <img
                                className="self-test-footer_statistic-item_image"
                                src={UrlService.getLocalImageUrl(
                                    "self-test/covid/img03.png?2"
                                )}
                                title="Stats 1"
                                alt="Stats 1"
                                data-loaded="true"
                            />
                            <div className="self-test-footer_statistic-item_text">
                                第五波確診個案
                                <p>
                                    已超過75萬⼈<sup>7</sup>
                                </p>
                            </div>
                        </div>
                        <div className="self-test-footer_statistic-item">
                            <img
                                className="self-test-footer_statistic-item_image"
                                src={UrlService.getLocalImageUrl(
                                    "self-test/covid/img04.png?1"
                                )}
                                title="Stats 2"
                                alt="Stats 2"
                            />
                            <div className="self-test-footer_statistic-item_text">
                                第五波死亡個案
                                <p>
                                    已超過9000⼈<sup>7</sup>
                                </p>
                            </div>
                        </div>
                        <div className="self-test-footer_statistic-item">
                            <img
                                className="self-test-footer_statistic-item_image"
                                src={UrlService.getLocalImageUrl(
                                    "self-test/covid/img05.png?1"
                                )}
                                alt="Stats 3"
                            />
                            <div className="self-test-footer_statistic-item_text">
                                根據醫管局，帕克斯洛維德 (Paxlovid) 和莫納⽪拉⾱(Molnupiravir) 分別可降低 死亡率80% 及40%<sup>8</sup>。
                            </div>
                        </div>
                    </div>
                    <div className="self-test-footer_statistic-lastestupdate">
                        *數字最後更新⽇期：2022 年 6 ⽉ 13 ⽇
                    </div>
                    <span className="self-test-footer_cta_button">
                        <span className="self-test-footer_button-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="11"
                                height="14"
                                className="self-test-footer_button-arrow"
                            >
                                <path
                                    fill="currentColor"
                                    fillRule="evenodd"
                                    d="M0 0l11 7-11 7z"
                                ></path>
                            </svg>
                        </span>
                        <a
                            className="self-test-footer_label"
                            href={UrlService.getBaseUrl(
                                "/doctors/covid22?itm_campaign=covid22&itm_source=button_click&itm_medium=description"
                            )}
                        >
                            查看已入藥的私家醫⽣名單
                        </a>
                    </span>
                </div>
            </div>
        </section>
    )
}

export default Footer
